import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { MessageSquarePlus } from 'blaze-ui/icons'
import { CreateCommentPrompt } from 'common/Prose/Prompts/CreateCommentPrompt/CreateCommentPrompt'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { observer } from 'mobx-react-lite'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useRootStore } from 'stores/RootStore'
import Styles from './FormatBar.module.scss'

interface Props {
  view: EditorView<typeof schema>
}

export const CommentButton = observer(({ view }: Props) => {
  const { queryClient, docStore } = useRootStore()
  const layerId = docStore?.layerId

  if (!docStore || !layerId) return null

  return (
    <DropdownTrigger restoreFocus={false} popoverClassName={Styles.commentPopover}>
      <IconButton size="sm" variant="editor" preventFocusOnPress icon={MessageSquarePlus} aria-label="Comment" />
      {(close) => (
        <CreateCommentPrompt
          id="comment-prompt"
          docStore={docStore}
          view={view}
          layerId={layerId}
          richText
          close={close}
          queryClient={queryClient}
        />
      )}
    </DropdownTrigger>
  )
})
